import React from "react";
import styled from "styled-components";
// import { Books } from 'models'
import { publishedDate, fixArabicText, getMetaValue } from "../../../helpers";
import { ReaderDoc } from "../PageContents";
import { THEME } from "../PageContents/styles";

const Container = styled.div<{ theme: string }>`
    user-select: none;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: center;
    background-color: ${(p) => THEME[p.theme]["code"]["borderColor"]};
`;
/*const Preview = styled.div`
    padding: 10px 10px 12px 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 140px;
`

const Cover = styled.img`
    width: 100%;
`*/

const Info = styled.div<{ theme: string }>`
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    margin-right: 10px;
    color: ${(p) => THEME[p.theme]["text"]["color"]};
`;

const Mark = styled.div``;

const Indent = styled.div`
    position: relative;
    margin-right: 30px;

    &:before {
        display: block;
        position: absolute;
        content: "\u2022";
        right: -18px;
        top: 1px;
    }
`;

const Name = styled.div`
    font-size: 30px;
    font-family: urdu, sans-serif;
    font-weight: 700;
    white-space: pre-wrap;

    [lang="ar"] {
        font-size: 10px;
    }
`;

const Authors = styled(Indent)`
    margin-top: 8px;
    font-size: 16px;
    font-family: urdu;
    font-weight: 500;
    white-space: pre-wrap;
`;

const PublishedOn = styled(Indent)`
    margin-top: 4px;
    font-size: 14px;
    font-family: urdu;
    font-weight: 500;
`;

const Intro = styled.div`
    font-size: 16px;
    white-space: pre-wrap;
    margin: 13px 0;
    font-weight: 500;
`;

type Props = {
    theme: string;
    doc: ReaderDoc;
};

export default class Header extends React.Component<Props> {
    render() {
        const { theme, doc } = this.props;
        const { doc_meta } = doc;
        // const coverImg = Books.url('GET', `${doc.id}/cover`)
        const authors = getMetaValue(doc_meta, "authors");
        const intro = getMetaValue(doc_meta, "intro")!;

        return (
            <Container theme={theme}>
                {/*<Preview>
                    <Cover theme={theme} src={coverImg} />
                </Preview>*/}

                <Info theme={theme}>
                    <Mark>
                        <Name
                            dangerouslySetInnerHTML={fixArabicText(doc.name)}
                        />
                        <Authors>{authors}</Authors>
                        <PublishedOn>
                            {publishedDate(new Date(doc.updated_at))}
                        </PublishedOn>
                    </Mark>
                    <Intro dangerouslySetInnerHTML={fixArabicText(intro!)} />
                </Info>
            </Container>
        );
    }
}
